'use strict';

productFilterRequest.$inject = ["Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productFilterRequest = productFilterRequest;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productFilterRequest(Enums) {
    var clazz = function ProductFilterRequest() {
        var defaults = {
            context: 0,
            DiscountTypeId: null,
            SellerId: null,
            SellerPortalProductCategoryTypeId: null,
            MediPimBrandId: null,
            CategoryId: null,
            ProductName: null,
            IsDiscountView: false,
            CacheFilter: false
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.createForHomePage = function () {
        var request = new clazz();
        request.context = Enums.searchContext.none.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForDiscounts = function (discountTypeId) {
        var request = new clazz();
        request.context = Enums.searchContext.discount.id;
        request.DiscountTypeId = discountTypeId;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = true;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSearch = function (searchValue) {
        var request = new clazz();
        request.context = Enums.searchContext.search.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = searchValue;
        request.IsDiscountView = false;
        request.CacheFilter = false;
        return request;
    };

    clazz.createForBrand = function (brandId) {
        var request = new clazz();
        request.context = Enums.searchContext.brand.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = brandId;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForCategory = function (categoryId) {
        var request = new clazz();
        request.context = Enums.searchContext.category.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = categoryId === 0 ? null : categoryId;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerProducts = function (sellerId, categoryId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = categoryId ? categoryId : null;
        request.MediPimBrandId = null;
        request.CategoryId = categoryId ? categoryId : null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerDiscounts = function (sellerId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = true;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerCategory = function (sellerId, sellerCategoryId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = sellerCategoryId;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerDetailDiscounts = function (sellerId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = true;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerDetailProducts = function (sellerId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/productFilterRequest.js
// module id = 774
// module chunks = 0